export default "__VITE_ASSET__8ff833b3__"